import NextImage from "@components/NextImage";
import SalesforceForm from "@components/Salesforce/SalesforceForm";
import {useTranslation} from "@i18n/client";
import React from "react";

const Contact: React.FC = () => {
  const i18n = useTranslation();
  return (
    <section
      aria-labelledby="contact-heading"
      className="bg-lightYellow pv30 pt14-sm pb20-xs ph8 pos-r contrast-tbb"
      id="get-started"
    >
      <div className="maxw70 ma df fdc-md zIndex1 pos-r">
        <div className="fx df mb10-md jcc-md">
          <div className="maxw26">
            <h2 className="fs32-xs mb5 mb2-xs maxw20" id="contact-heading">
              {i18n.t("Get in touch with our team")}
            </h2>
            <p className="fs24 fs22-sm fs16-xs font-ir-xs font-cm">
              {i18n.t(
                "We'd love to hear how Carbon Health can partner with your organization to better serve your patients and your community. We’ll respond within one business day.",
              )}
            </p>
          </div>
        </div>
        <div className="fx df jcfe jcc-md">
          <div className="bs2 hfc bg-white maxw28-sm maxw32 w100p contrast-tb">
            <SalesforceForm
              submitButtonLabel={i18n.t("Contact Us")}
              channel="partners"
              trackingCategory="Carbon Partners"
              emailFieldLabel={i18n.t("Work email address")}
              excludedFields={["title"]}
            />
          </div>
        </div>
      </div>
      <div className="pos-a right0 bottom0 minh40-xs minw40-xs w50rem h18rem">
        <NextImage src="/illustrations/squiggly-lines-yellow" layout="fill" alt="" />
      </div>
    </section>
  );
};

export default Contact;
